import React from 'react';
import LoginForm from '../forms/LoginForm';

function Login() {
    return (
        <div>
            <LoginForm />
        </div>
    );
}

export default Login;